import { MIC_MUTED, AUDIO_MUTED, HEAD_LIGHT, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    mic: true,
    audio: false,
    headlight: false,
}

export const soundReducer = (state = initialState, action) => {
    switch (action.type) {
        case MIC_MUTED:
            return {
                ...state,
                mic: action.payload
            }
        case AUDIO_MUTED:
            return {
                ...state,
                audio: action.payload
            }
        case HEAD_LIGHT:
            return {
                ...state,
                headlight: action.payload
            }
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}